import { render, staticRenderFns } from "./BrandedCoinUpload.vue?vue&type=template&id=afa3a450&scoped=true&"
import script from "./BrandedCoinUpload.vue?vue&type=script&lang=ts&"
export * from "./BrandedCoinUpload.vue?vue&type=script&lang=ts&"
import style0 from "./BrandedCoinUpload.vue?vue&type=style&index=0&id=afa3a450&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa3a450",
  null
  
)

export default component.exports